import axios from "axios";

const def_options = {
  params: {
    limit: 50
  }
};

const GET_USERS = "/users.json";
const GET_TENTRIES = "/time_entries.json";
const GET_PROJECTS = "/projects.json";
const GET_ISSUES = "/issues.json";
const GET_QUERIES = "/queries.json";

// const GET_ISSUE = "/issues/%d.json";

export type TimeEntriesResponse = {
  time_entries: TimeEntries[];
  total_count: number;
  offset: number;
  limit: number;
};

export type TimeEntries = {
  id: number;
  project: any;
  issue: any;
  user: any;
  activity: any;
  hours: 2;
  comments: string;
  spent_on: string;
  created_on: Date;
  updated_on: Date;
  custom_fields: [];
};

export type TimeEntriesByDay = {
  user?: any;
  hours?: { spent_on: string; hours: number; mbf: number }[];
};

export class RedmineClient {
  _token = "";
  _url = "";

  constructor(url = "", apiToken = "") {
    this._token = apiToken;
    this.setURL(url);
    this._setAuthHeaders();
  }
  /* PRIVATE METHODS */
  _setAuthHeaders() {
    axios.defaults.headers.common["X-Redmine-API-Key"] = this._token;
  }

  _cmd = (cmd = "") => {
    return this._url + cmd;
  };

  async _doRequest(url: string, params: any): Promise<any> {
    const options = {
      ...def_options,
      params: { ...def_options.params, ...params }
    };

    try {
      const response = await axios.get(url, options);
      const data = response["data"];

      // check if there are more records in pagination
      if (data.total_count != undefined && data.total_count > data.limit) {
        // need to retrieve more data.
        // request again the page 0. This is not efficient but simplify the flow
        const requests = [];
        let steps = Math.floor(data.total_count / data.limit);

        if (data.total_count % data.limit > 0) {
          steps++;
        }

        for (let page = 1; page <= steps; page++) {
          // get more
          options.params.page = page;
          // prepare
          requests.push(axios.get(url, options));
        }

        if (requests.length > 0) {
          try {
            const results = await axios.all(requests);
            return results;
          } catch (error) {
            console.log("error :>> ", error);
            return error;
          }
        }
      } else {
        return data;
      }
    } catch (error) {
      console.log("AXIOS ERROR: ", error);
      return error;
    }
  }

  /* PUBLIC METHODS */
  setURL(url: string) {
    this._url = url;
    axios.defaults.baseURL = this._url;
  }

  setToken(apiToken: string) {
    this._token = apiToken;
    this._setAuthHeaders();
  }

  /* REQUESTS */
  async getUsers<T>(filters: any): Promise<T> {
    const results = await this._doRequest(this._cmd(GET_USERS), filters);
    return results;
  }

  async getTimeEntries<T>(params: any): Promise<T> {
    const results = await this._doRequest(this._cmd(GET_TENTRIES), params);
    return results;
  }

  async getProjects<T>(params: any): Promise<T> {
    const results = await this._doRequest(this._cmd(GET_PROJECTS), params);
    return results;
  }

  async getIssues<T>(params: any): Promise<T> {
    const results = await this._doRequest(this._cmd(GET_ISSUES), params);
    return results;
  }

  // async getIssue<T>(params: any): Promise<T> {
  //   const results = await this._doRequest(
  //     this._cmd(util.format(GET_ISSUE, issueId)),
  //     params
  //   );
  //   return results;
  // }

  async getQueries2<T>(): Promise<T> {
    const results = await this._doRequest(this._cmd(GET_QUERIES), {});
    return results;
  }

  async getTimeEntriesByDay(params: any): Promise<TimeEntriesByDay[]> {
    const data = [] as TimeEntriesByDay[];

    try {
      const response = await this._doRequest(this._cmd(GET_TENTRIES), params);

      // reduce response
      let buffer = [] as TimeEntries[];

      if (!("time_entries" in response)) {
        buffer = response.reduce((previous: any, current: any) => {
          return previous.concat(current.data.time_entries);
        }, []);
      } else {
        buffer = response.time_entries;
      }

      // group by day
      let day: any | undefined = {};
      // console.log(buffer);
      buffer.forEach((element) => {
        // console.log(element);
        let user_data: TimeEntriesByDay = {};

        // search for user_id
        const user = data?.find((tmp) => tmp.user.id == element.user.id);

        // console.log(element.id, element.hours);
        if (user == undefined) {
          // no user found, create a new one
          user_data = { user: element.user, hours: [] };
          data.push(user_data);
        } else {
          user_data = user;
        }

        day = user_data.hours?.find(
          (day) => day.spent_on == (element.spent_on as any)
        ) as any | undefined;

        // cerco il campo mbf nel custom field
        const custom_fields_mbf: any = element.custom_fields?.find(
          (item: any) => {
            return item.name === "MBF";
          }
        );

        const mbf =
          custom_fields_mbf && custom_fields_mbf.value
            ? parseFloat(custom_fields_mbf.value)
            : 0;

        if (day === undefined) {
          // no day found

          user_data.hours?.push({
            spent_on: element.spent_on,
            hours: element.hours,
            mbf
          });
        } else {
          // day found
          day.hours = day.hours + element.hours;
          day.mbf = day.mbf + mbf;
        }
        // console.log(element.user.id);
      });

      return data;
    } catch (error: any) {
      return error;
    }
  }

  getToken() {
    return this._token;
  }
}
